﻿export default class NewsSeen {
  constructor (obj) {
    if (obj) {
      obj && Object.assign(this, obj)
      return
    }

    this.ID = 0
    this.NewsRef = 0
    this.UserIDRef = 0
    this.UserName = ''
    this.TimeSeen = ''
  }
}
